<template>
    <div>
        <!--采购报表-->
        <Card :bordered="false" dis-hover>
            <p slot="title">详情</p>
            <Row>
                <Col span="8"><strong>客户：</strong> <span class="result">{{purchase.customer.name}}</span></Col>
                <Col span="8"><strong>单据编号：</strong> <span class="result">{{purchase.markcode}}</span></Col>
                <Col span="8"><strong>制单日期：</strong> <span class="result">{{purchase.time}}</span></Col>
                <Col span="8"><strong>收款账户：</strong> <span class="result">{{purchase.bankmarket[0].bankname}}</span></Col>
                  <Col span="8"><strong>总金额：</strong> <span class="result">￥{{purchase.totalmoney}}</span></Col>
                 <Col span="8"><strong>总数量：</strong> <span class="result">{{purchase.total}}</span></Col>
                 <Col span="8"><strong>实收合计：</strong> <span class="result">￥{{purchase.paymoney}}</span></Col>
                 <Col span="8"><strong>客户欠款：</strong> <span class="result">￥{{purchase.nomoney}}</span></Col>
                 <Col span="8"><strong>抹零金额：</strong> <span class="result">{{purchase.removemoney}}</span></Col>
                 <Col span="8"><strong>优惠金额：</strong> <span class="result">{{purchase.discountsmoney}}</span></Col>
                 <Col span="8"><strong>业务员：</strong> <span class="result">{{purchase.adminName}}</span></Col>
                 <Col span="24"><strong>收货地址：</strong> <span class="result">{{purchase.way}}</span></Col>
            </Row>
        </Card>
        <table slot="content" class="ive-table" v-for="(item, index) in purchase.goodslist" :key="index">
            <thead>
            <th>商品详情</th>
            <th>名称/货号</th>
            <th>规格/颜色</th>
            <th>单价</th>
            <th>数量</th>
            </thead>
            <tbody>
            <tr align="center" v-for="(k,v) in purchase.goodslist[index].goodsItem">
                <td width="300" :rowspan="v" v-if="v==0">
                    <Fy-Img
                            class="img"
                            :ImgSrc="item.goodsimg | filtImg(item.goodsimg)"
                            :Width="100"
                            :Height="100"
                    ></Fy-Img>
                </td>
                <td>{{item.goodsname}} / {{item.goodscode}}</td>
                <td>{{k.size}} / {{k.color}}</td>
                <td>{{k.cprice}}</td>
                <td>{{k.quantity}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                cid:'',
                sid:'',
                purchase:{}
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.getMarketId(this.$route.query.id)
        },

        methods: {
            //获取采购单
            getMarketId(id){
                this.$Api.getMarketId({
                    id:id
                }).then(res => {
                    if(res.code==200){
                        this.purchase = res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },


        }
    };
</script>

<style lang="scss" scoped>
    .form-title{

        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
    .result{
        display: inline-block;
        margin-bottom: 15px;
    }
    .ive-table{
        margin-top: 20px;
        width: 100%;
        border-collapse: collapse;
        th{
            background: #bfdeff;
            padding: 10px;
        }
        tr td{
            border: 1px solid #ececec;
            padding: 10px;
        }
    }
</style>